import { render, staticRenderFns } from "./PaginationItem.vue?vue&type=template&id=d5682be8&scoped=true"
import script from "./PaginationItem.vue?vue&type=script&lang=ts"
export * from "./PaginationItem.vue?vue&type=script&lang=ts"
import style0 from "./PaginationItem.vue?vue&type=style&index=0&id=d5682be8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5682be8",
  null
  
)

export default component.exports